import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card shadow-sm mb-4" }
const _hoisted_2 = {
  class: "card-body",
  style: {"height":"300px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bar_chart = _resolveComponent("bar-chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h6", { class: "mb-0" }, [
        _createElementVNode("i", { class: "fas fa-chart-bar fa-fw me-1" }),
        _createTextVNode(" Distribución de Stakes y Resultados por Día ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_bar_chart, {
        data: _ctx.chartData,
        options: _ctx.chartOptions
      }, null, 8, ["data", "options"])
    ])
  ]))
}